import React from 'react';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import { Link } from 'react-router-dom';
export default props => {
  return (
    <React.Fragment>
      {props.id !== undefined && (
        <div>
          {props.link !== undefined ? (
            <Link to={`/lenders/${props.id}`} target={props.target}>
              {props.name}
            </Link>
          ) : (
            props.name
          )}
          <br />
          {props.lpc}
          <br />
          {props.address_line_1 !== null && props.address_line_1.length > 0 && (
            <React.Fragment>
              {props.address_line_1}
              <br />
            </React.Fragment>
          )}
          {props.address_line_2 !== null && props.address_line_2.length > 0 && (
            <React.Fragment>
              {props.address_line_2}
              <br />
            </React.Fragment>
          )}
          <AddressHelper
            {...props}
            address_line_1={null}
            address_line_2={null}
          />
        </div>
      )}
    </React.Fragment>
  );
};
